module.exports = __webpack_public_path__ + "img/xianyi1.bef346f7.png";